<template>
    <div>
        <!-- First Section -->
        <!-- Boost Your Event Success Section -->
        <section class="py-5 bg-white">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <h1 class="mb-3 text-8 font-weight-bold">
                            Boost your event's success with secure, easy-to-use online tickets from Magetsi
                        </h1>
                        <p class="text-3 mb-4 mt-3">
                            Create an unforgettable experience for your customers with security guaranteed.
                        </p>

                        <!-- Add a margin-bottom to the button container -->
                        <div class="text-center text-md-left mt-4 mb-5">
                            <a href="/business/register" class="btn btn-registration-solid">SIGN UP</a>
                            <a href="/business/auth" class="btn btn-registration-outline">SIGN IN</a>
                        </div>
                    </div>
                    <div class="col-md-6 text-center">
                        <img src="/images/event-ticketing.webp" class="img-fluid" alt="Boost Event Image" style="border-radius: 10px;">
                    </div>

                </div>
            </div>
        </section>



        <!-- Online Platform Ticketing Features Section -->
        <div class="container my-5 text-3 mb-4 mt-3">
            <h2 class="text-center mb-5 font-weight-bold text-7">Online Platform Ticketing Features</h2>

            <div class="row my-4">
                <div class="col-md-6">
                    <h5>

                        <svg class="mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#3498db" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5.464V3.099m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C19 17.4 19 18 18.462 18H5.538C5 18 5 17.4 5 16.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 12 5.464ZM6 5 5 4M4 9H3m15-4 1-1m1 5h1M8.54 18a3.48 3.48 0 0 0 6.92 0H8.54Z"/>
                        </svg>
                        Online Ticket Inventory Management
                    </h5>
                    <p>Track your event's ticket sales in real time, giving you full control over inventory and ensuring a sold-out event!</p>
                </div>

                <div class="col-md-6">
                    <h5>

                        <svg class="mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#e74c3c" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.6 16.733c.234.269.548.456.895.534a1.4 1.4 0 0 0 1.75-.762c.172-.615-.446-1.287-1.242-1.481-.796-.194-1.41-.861-1.241-1.481a1.4 1.4 0 0 1 1.75-.762c.343.077.654.26.888.524m-1.358 4.017v.617m0-5.939v.725M4 15v4m3-6v6M6 8.5 10.5 5 14 7.5 18 4m0 0h-3.5M18 4v3m2 8a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"/>
                        </svg>
                        Secure Payment & History Log
                    </h5>
                    <p>Enjoy peace of mind with our secure payment gateway, keeping your transactions safe while providing easy access to detailed sales logs post-event.</p>
                </div>
            </div>

            <div class="row my-4">
                <div class="col-md-6">
                    <h5>

                        <svg class="mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#2ecc71" viewBox="0 0 24 24">
                            <path fill-rule="evenodd" d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" clip-rule="evenodd"/>
                        </svg>
                        Encrypted Tickets
                    </h5>
                    <p>Ensure only valid attendees gain entry with one-use encrypted E-tickets, reducing fraud and boosting event security.</p>
                </div>

                <div class="col-md-6">
                    <h5>

                        <svg class="mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#f1c40f" viewBox="0 0 24 24">
                            <path fill-rule="evenodd" d="M10 5a2 2 0 0 0-2 2v3h2.4A7.48 7.48 0 0 0 8 15.5a7.48 7.48 0 0 0 2.4 5.5H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1V7a4 4 0 1 1 8 0v1.15a7.446 7.446 0 0 0-1.943.685A.999.999 0 0 1 12 8.5V7a2 2 0 0 0-2-2Z" clip-rule="evenodd"/>
                            <path fill-rule="evenodd" d="M10 15.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm6.5-1.5a1 1 0 1 0-2 0v1.5a1 1 0 0 0 .293.707l1 1a1 1 0 0 0 1.414-1.414l-.707-.707V14Z" clip-rule="evenodd"/>
                        </svg>
                        Magetsi Scanning App
                    </h5>
                    <p>Only event organizers can scan tickets using the Magetsi App, ensuring absolute control over ticket validation and event security.</p>
                </div>
            </div>
        </div>

        <!-- Take Your Customers on a Seamless Ticketing Journey Section -->
        <section class="py-5 bg-white">
            <div class="container">
                <h2 class="text-center text-7 font-weight-bold mb-4 py-5">Take Your Customers on a Seamless Ticketing Journey</h2>

                <div class="row text-left text-3 mb-4 mt-3">
                    <!-- Buying On The Website -->
                    <div class="col-md-6 mb-4">
                        <h5 class="mb-3">Buying On The Website</h5>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <strong>1.</strong> Visit <a href="https://magetsi.co.zw/tickets">https://magetsi.co.zw/tickets</a>.
                            </li>
                            <li class="mb-2">
                                <strong>2.</strong> Pick the event of your choice, & Insert the delivery number and email address.
                            </li>
                            <li class="mb-2">
                                <strong>3.</strong> Pay via Ecocash or an International card & receive your ticket.
                            </li>
                        </ul>
                    </div>

                    <!-- Buying on WhatsApp -->
                    <div class="col-md-6 mb-4">
                        <h5 class="mb-3">Buying on WhatsApp</h5>
                        <ul class="list-unstyled">
                            <li class="mb-2">
                                <strong>1.</strong> Say Hi to Magetsi Chatbot.
                            </li>
                            <li class="mb-2">
                                <strong>2.</strong> Input your information (delivery number, email address, payment method) in conversation format.
                            </li>
                            <li class="mb-2">
                                <strong>3.</strong> Receive Your Ticket.
                            </li>
                        </ul>
                    </div>
                </div>


                <div class="row">
                    <div class="col text-center">
                        <a href="/business/register" class="btn btn-registration-solid btn-lg mt-4 px-5">GET STARTED NOW!</a>
                    </div>
                </div>
            </div>
        </section>



        <!-- Get Started Today Section -->
        <section class="py-5 text-3 mb-4 mt-3">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center order-md-2">
                        <img src="/images/events-landing.webp" alt="Get Started Today" class="img-fluid">
                    </div>
                    <div class="col-md-6 text-center text-md-left order-md-1">
                        <h2 class="font-weight-bold mb-4 py-5 text-7">
                            Get started today and enjoy the exclusive benefits of streamlined, secure online ticketing
                        </h2>
                        <div class="row text-left">
                            <div class="col-12 mb-3">
                                <h5 class="font-weight-bold">Save Time & Money</h5>
                                <p>Streamlined processes & reduced fees.</p>
                            </div>
                            <div class="col-12 mb-3">
                                <h5 class="font-weight-bold">Increased Sales</h5>
                                <p>Reach new audiences & boost ticket sales.</p>
                            </div>
                            <div class="col-12 mb-3">
                                <h5 class="font-weight-bold">Seamless Distribution</h5>
                                <p>Securely deliver tickets & prevent fraud.</p>
                            </div>
                            <div class="col-12 mb-3">
                                <h5 class="font-weight-bold">Dedicated Support</h5>
                                <p>Our team is here to help you every step of the way.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>


<script>
export default {
    name: 'Content',
};


</script>


<style scoped>
h5 {
    font-weight: 600;
    font-size: 18px;
}

ul {
    list-style: none;
    padding: 0;
}

li {
    font-size: 16px;
    line-height: 1.6;
}

a {
    color: #023161;
    text-decoration: none;
}

.btn-registration-solid {
    background-color: #1A245C;
    color: white;
    border: 1px solid #1A245C;
    border-radius: 4px;
    padding: 8px 24px;
    font-weight: bold;
    display: inline-block;
    text-align: center;
}

.btn-registration-outline {
    background-color: transparent;
    color: #1A245C;
    border: 1px solid #1A245C;
    border-radius: 4px;
    padding: 8px 24px;
    font-weight: bold;
    display: inline-block;
    text-align: center;
}

.btn-registration-solid:hover,
.btn-registration-outline:hover {
    background-color: #1A245C;
    color: white;
}


</style>
